import {
  Box,
  Coin,
  DataAnalysis,
  Document,
  Download,
  Goods,
  House,
  List,
  Location,
  Lock,
  Notebook,
  OfficeBuilding,
  Share,
  Tickets,
  Upload,
  User,
  Van,
  Warning,
} from '@element-plus/icons-vue'
import type { Component } from 'vue'

/**
 * 侧边栏图标表：键就是权限清单（各服务 permissions.yaml）里的 icon 值。
 * 逐个具名导入而不是 `import *`：通配导入 + 动态下标会让整包图标（含用不到的几百个）进 bundle。
 * 清单新增图标时在这里补一行；不在表里的名字会退回文字显示，不会报错。
 */
export const ICONS: Record<string, Component> = {
  Box,
  Coin,
  DataAnalysis,
  Document,
  Download,
  Goods,
  House,
  List,
  Location,
  Lock,
  Notebook,
  OfficeBuilding,
  Share,
  Tickets,
  Upload,
  User,
  Van,
  Warning,
}
